/*
  NordiskPuls - "har kunden taget imod gaven?" og "har hun sagt nej tak?"
  =================================================================
  Eet sted at laese og saette begge dele, fordi baade gavemotoren og
  gave-popup'en har brug for dem. Skal indlaeses FOER dem begge.

  TO SPOERGSMAAL, IKKE ET - og det var fejlen foer
  Da hun skrev sin mail, satte vi eet flag der betoed begge dele:
  "hun har RET til gaven" og "vis ikke popup'en igen". De to ting har
  ikke samme levetid.
    RETTEN skal holde. Ellers mister hun gaven hun lige har sagt ja til,
    naeste gang hun aabner siden - motoren skal blive ved med at lagge
    coveret i kurven naar der er en Pulsen Pro i den.
    AFBRYDELSEN skal IKKE holde. Hun gav sin mail, men koebte ikke. Saa
    skal hun mindes om gaven naeste gang hun kigger forbi, ikke bare
    have den liggende usynligt i et flag.
  Derfor: har() er permanent (cookie + localStorage) og laeses af
  motoren. svaretNu() lever kun i denne fane og laeses af popup'en.

  HVORFOR BAADE COOKIE OG localStorage
  Safari (ITP) kapper cookies sat fra JavaScript til 7 dage, uanset hvad
  vi skriver i expires. En kunde der har taget imod gaven ville altsaa
  miste retten til den ugen efter. localStorage rammes ikke af den regel.
  Vi skriver begge steder og accepterer det foerste der svarer ja.

  HVORFOR IKKE BARE SPOERGE KLAVIYO
  Klaviyos egen __kla_id lever ogsaa kun 24 timer til 7 dage i Safari, og
  i EU kan Shopifys samtykke-indstillinger helt slaa Klaviyos onsite-
  tracking fra - saa isIdentified() svarer false for en kunde vi udmaerket
  kender. Vores eget flag er derfor sandheden; Klaviyo er kun et signal om
  HVILKEN popup der skal vises.
*/
(function () {
  'use strict';

  var NOEGLE = 'np_gave_mail';
  var SVARET = 'np_gave_svaret';   // kun dette besoeg

  function fraCookie() {
    return document.cookie.split('; ').some(function (c) {
      return c.indexOf(NOEGLE + '=1') === 0;
    });
  }

  function fraLager() {
    try { return localStorage.getItem(NOEGLE) === '1'; } catch (e) { return false; }
  }

  window.npGaveFlag = {
    // RETTEN til gaven. Permanent. Laeses af np-gavemotor.js.
    har: function () { return fraLager() || fraCookie(); },

    // Har hun svaret i DETTE besoeg? Laeses af np-gavepopup.js, saa
    // popup'en ikke kommer igen paa samme sidevisning - men er tilbage
    // naeste gang hun aabner siden, hvis hun ikke har koebt.
    // sessionStorage er pr. fane: lukker hun fanen, er svaret glemt.
    svaretNu: function () {
      try { return sessionStorage.getItem(SVARET) === '1'; } catch (e) { return false; }
    },

    gem: function () {
      var d = new Date(); d.setDate(d.getDate() + 180);
      document.cookie = NOEGLE + '=1; path=/; expires=' + d.toUTCString() + '; SameSite=Lax';
      try { localStorage.setItem(NOEGLE, '1'); } catch (e) {}
      try { sessionStorage.setItem(SVARET, '1'); } catch (e) {}
    },

    // Kun til test
    ryd: function () {
      document.cookie = NOEGLE + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
      try { localStorage.removeItem(NOEGLE); } catch (e) {}
      try { sessionStorage.removeItem(SVARET); } catch (e) {}
    }
  };

  /* ---------- "Nej tak" ----------

     Historik, saa ingen skruer den op igen uden at vide hvorfor:
     Foerst laa svaret i sessionStorage - altsaa glemt naar fanen blev
     lukket. Saa blev det sat til 30 dage, fordi et nej boer respekteres
     laengere end en fane. 30 dage var for meget: en kunde der siger nej
     tak tirsdag og vender tilbage torsdag med koebslyst faar intet at
     vide om gaven, og saa er tilbuddet reelt vaek for hende.

     Nu: 2 timer. Langt nok til at hun ikke bliver afbrudt igen i det
     samme indkoebsaerinde, kort nok til at et besoeg samme aften eller
     naeste dag moeder tilbuddet paa ny.

     Den flydende gave-knap staar der uanset hvad (se np-gavepopup.js) -
     det er kun AFBRYDELSEN der holder pause, ikke adgangen til gaven.

     Ligger her sammen med flaget ovenfor, fordi baade motoren og popup'en
     skal laese det samme. Havde de hver sin kopi, kunne popup'en tro at
     kunden havde sagt nej mens motoren troede det modsatte - og saa ville
     gaven lande i kurven uden at nogen havde spurgt om den.
  */

  var AFVIST = 'np_gave_afvist_';
  var AFVIST_MS = 2 * 60 * 60 * 1000;   // 2 timer

  window.npGaveAfvist = {
    er: function (udloeser) {
      try {
        return parseInt(localStorage.getItem(AFVIST + udloeser) || '0', 10) > Date.now();
      } catch (e) { return false; }
    },
    saet: function (udloeser) {
      try {
        localStorage.setItem(AFVIST + udloeser, String(Date.now() + AFVIST_MS));
      } catch (e) {}
    },
    // Kun til test
    ryd: function (udloeser) {
      try { localStorage.removeItem(AFVIST + udloeser); } catch (e) {}
    }
  };
})();
